import axios from "axios";
 import { base_url } from "../../utils/baseUrl";

// Get all projects
const getProjects = async () => {
  const response = await axios.get(`${base_url}project/`);
  return response.data;
};

 

const projectService = {
  getProjects,
 
};

export default projectService;
